export default "__VITE_ASSET__CiKKgjM___"